import React, {useEffect, useState} from 'react';
import classnames from "classnames";
import MobileHero from "../containers/helpers/MobileHero";
import InfoSection from "./home/InfoSection";

import { homeObjEight, homeObjEightMobile } from "../pages/BB3Product.js";

import styles from "../styles/Downloads.module.scss";


const BBWInfoSection = () => {

    useEffect(() => {
        const handleWindowResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener("resize", handleWindowResize);
    
        return () => {
          window.removeEventListener("resize", handleWindowResize);
        };
      });

    const mobileBreakPoint = 769;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    return (
        <>
        {             windowWidth >= mobileBreakPoint ? (
              <InfoSection {...homeObjEight}>
              <div style={{display: 'flex' }}>
                <img
                  src={process.env.REACT_APP_BBW_QR_CODE}
                  alt="QR Code"
                  className={classnames(styles.qrCode, styles.storeIcons)}
                />
                <div style={{paddingLeft: '2em'}}>
                  <a
                      href={process.env.REACT_APP_HOMEPAGE_APPLE_APP_STORE_LINK_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.appStoreButton}
                    >
                      <img
                        className={classnames(styles.appStoreIcon, styles.storeIcons)}
                        src={"https://frontend-assets.buildbox.com/AppStoreButton.png"}
                        alt="Buildbox World App Store Button"
                      />
                    </a>
                    <a
                      href={process.env.REACT_APP_HOMEPAGE_GOOGLE_PLAY_STORE_LINK_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.appStoreButton}
                        >
                        <img
                          className={classnames(styles.appStoreIcon, styles.storeIcons)}
                          src={"https://frontend-assets.buildbox.com/GooglePlay.webp"}
                          alt="Buildbox World Google Play Button"
                        />
                    </a>
                  </div>
                </div>
            </InfoSection>
          ) : (
            <MobileHero {...homeObjEightMobile}>
              <div>
                <a
                  href={process.env.REACT_APP_HOMEPAGE_APPLE_APP_STORE_LINK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.appStoreButton}
                >
                  <img
                    className={classnames(styles.appStoreIcon, styles.storeIcons)}
                    src={"https://frontend-assets.buildbox.com/AppStoreButton.png"}
                    alt="Buildbox World App Store Button"
                  />
                </a>
                <a
                  href={process.env.REACT_APP_HOMEPAGE_GOOGLE_PLAY_STORE_LINK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.appStoreButton}
                    >
                    <img
                      className={classnames(styles.appStoreIcon, styles.storeIcons)}
                      src={"https://frontend-assets.buildbox.com/GooglePlay.webp"}
                      alt="Buildbox World Google Play Button"
                    />
                </a>
              </div>
            </MobileHero>
            )}
        </>
    )
}

export default BBWInfoSection
